import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React from 'react';
import dynamic from 'next/dynamic';
var PerformanceAdminPanel = dynamic(() => import(
/* webpackChunkName: "AdminTools" */
'./PerformanceAdminPanel'));
export default function performanceExtension() {
  return {
    id: 'performance',
    admin: {
      panels: [/*#__PURE__*/React.createElement(PerformanceAdminPanel, {
        key: "performance"
      })]
    },
    server: process.browser ? undefined : {
      init(server) {
        var instrumentServer = require('./instrumentServer').default;

        instrumentServer(server);
      },

      handler(_ref) {
        var handler = _ref.handler;

        var instrumentHandler = require('./instrumentHandler').default;

        return instrumentHandler(handler);
      }

    },
    document: process.browser ? undefined : {
      getInitialProps: {
        enhance(getInitialProps) {
          return /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(function* (ctx) {
              var renderPage = ctx.renderPage;
              var performance = ctx.req.performance; // Instrument `renderPage` to capture app render time.

              ctx.renderPage = function () {
                var entry = {
                  type: 'next',
                  name: 'app.render'
                };
                performance.entries.push(entry);
                var startTime = process.hrtime();
                var result = renderPage(...arguments);
                var endTime = process.hrtime();
                performance.timings.renderPageStart = performance.getOffset(startTime);
                performance.timings.renderPageEnd = performance.getOffset(endTime);
                entry.startTime = performance.timings.renderPageStart;
                entry.duration = performance.getDuration(startTime, endTime);
                return result;
              };

              var entry = {
                type: 'next',
                name: 'document.getInitialProps'
              };
              performance.entries.push(entry);
              var startTime = process.hrtime();
              var initialProps = yield getInitialProps(ctx);
              var endTime = process.hrtime();
              performance.timings.docInitialPropsStart = performance.getOffset(startTime);
              performance.timings.docInitialPropsEnd = performance.getOffset(endTime);
              entry.duration = performance.getDuration(startTime, endTime);
              entry.startTime = performance.timings.docInitialPropsStart;
              return initialProps;
            });

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }();
        }

      }
    },
    app: process.browser ? undefined : {
      getInitialProps: {
        enhance(getInitialProps) {
          return /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(function* (_ref3) {
              var Component = _ref3.Component,
                  ctx = _ref3.ctx;
              var performance = ctx.req.performance;
              var entry = {
                type: 'next',
                name: 'app.getInitialProps'
              };
              performance.entries.push(entry);
              var startTime = process.hrtime();
              var initialProps = yield getInitialProps({
                Component,
                ctx
              });
              var endTime = process.hrtime();
              performance.timings.appInitialPropsStart = performance.getOffset(startTime);
              performance.timings.appInitialPropsEnd = performance.getOffset(endTime);
              entry.duration = performance.getDuration(startTime, endTime);
              entry.startTime = performance.timings.appInitialPropsStart;
              return initialProps;
            });

            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }();
        }

      }
    }
  };
}